import React from 'react'
import Banner from '../Components/Banner/Banner'
import CryotoTable from '../Components/CryotoTable'

function HomePage() {
  return (
    <>
      <Banner />
      <CryotoTable />
    </>
  )
}

export default HomePage